import React from 'react';
import { Outlet } from 'react-router-dom';
import { RadixConnectProvider } from '../../radix_connect';
import { dAppDefinitionAddress } from '../../constants';

const MainLayout = () => {
  return (
    <RadixConnectProvider dAppDefinitionAddress={dAppDefinitionAddress}>
      <Outlet />
    </RadixConnectProvider>
  );
};

export default MainLayout;